import { useSelector as useSelectorBase } from 'react-redux'
import { RootState } from './rootReducer'

export { useDispatch } from 'react-redux'
export * from './StoreProvider'
export type { RootState } from './rootReducer'

export const useSelector = useSelectorBase.withTypes<RootState>()

export { userActions } from './user.slice'
export { dashboardActions } from './dashboard.slice'
export { settingActions } from './setting.slice'
export { systemActions } from './system.slice'
export { reportActions } from './report.slice'
